;(function () {
  function ApplicationMenu(element) {
    this.el = element
    this.el.querySelector(".application-menu__button").addEventListener(
      "click",
      function (e) {
        this._handleButtonClick()
      }.bind(this)
    )
  }

  ApplicationMenu.prototype._emit = function (eventName) {
    var event
    if (typeof Event === "function") {
      event = new Event(eventName)
    } else {
      event = document.createEvent("Event")
      event.initEvent(eventName, true, true)
    }

    this.el.dispatchEvent(event)
  }

  ApplicationMenu.prototype._pressButton = function () {
    this.el.querySelector(".application-menu__button").setAttribute("aria-pressed", "true")

    this._emit("press.application-menu")
  }

  ApplicationMenu.prototype._unpressButton = function () {
    this.el.querySelector(".application-menu__button").setAttribute("aria-pressed", "false")

    this._emit("unpress.application-menu")
  }

  ApplicationMenu.prototype._expandMenu = function () {
    this.el.querySelector(".application-menu__menu").setAttribute("aria-expanded", "true")

    this._emit("expand.application-menu")
  }

  ApplicationMenu.prototype._contractMenu = function () {
    this.el.querySelector(".application-menu__menu").setAttribute("aria-expanded", "false")

    this._emit("contract.application-menu")
  }

  ApplicationMenu.prototype._handleButtonClick = function () {
    var pressed = this.el.querySelector(".application-menu__button").getAttribute("aria-pressed")

    if (pressed === "true") {
      this.close()
    } else {
      this.open()
    }
  }

  ApplicationMenu.prototype.open = function () {
    this._pressButton()
    this._expandMenu()

    this._emit("open.application-menu")
  }

  ApplicationMenu.prototype.close = function () {
    this._unpressButton()
    this._contractMenu()

    this._emit("close.application-menu")
  }

  window.SOMAR = window.SOMAR || {}
  window.SOMAR.ApplicationMenu = ApplicationMenu
})()

;(function () {
  function init() {
    var elements = document.querySelectorAll(".application-menu")
    var applicationMenus = []

    if (elements.length === 0) {
      return
    }

    for (var i = 0; i < elements.length; i += 1) {
      applicationMenus.push(new window.SOMAR.ApplicationMenu(elements[i]))
    }

    // Automatically close menus when the user clicks away.
    document.addEventListener("click", function (event) {
      applicationMenus.forEach(function (menu) {
        if (menu.el !== event.target && !menu.el.contains(event.target)) {
          var dontCloseOnDocumentClick = menu.el.classList.contains("js-application-menu--no-on-window-close")
          if (!dontCloseOnDocumentClick) {
            menu.close()
          }
        }
      })
    })
  }

  init()
})()
